import { FC } from 'react';

import { useDividendsDistributionModal } from '../context/DividendsDistributionModalContext';
import DividendsTableRow from './DividendsTableRow';

const DividendsTableBody: FC = () => {
  const { data } = useDividendsDistributionModal();

  return (
    <tbody>
      {data.dividends.map((dividend, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <tr className="tb-tnx-item" key={`dividend-row-${index}`}>
          <DividendsTableRow index={index} dividend={dividend} />
        </tr>
      ))}
    </tbody>
  );
};

export default DividendsTableBody;
